export const SUPPLIER_ORDER_ACTIVE_STATUS_VALUES = [
  'DRAFT',
  'SENT',
  'CONFIRMED',
  'IN_PRODUCTION',
  'READY',
  'SHIPPED',
  'PARTIALLY_RECEIVED',
  'RECEIVED',
  'ON_HOLD',
  'CANCELLED',
] as const;

export const SUPPLIER_ORDER_LEGACY_STATUS_VALUES = ['PARTIALLY_READY'] as const;

export const SUPPLIER_ORDER_STATUS_VALUES = [
  ...SUPPLIER_ORDER_ACTIVE_STATUS_VALUES,
  ...SUPPLIER_ORDER_LEGACY_STATUS_VALUES,
] as const;

export type ActiveSupplierOrderStatus = typeof SUPPLIER_ORDER_ACTIVE_STATUS_VALUES[number];
export type SupplierOrderStatus = typeof SUPPLIER_ORDER_STATUS_VALUES[number];
